import { useEffect } from "react";
import { logAnalyticsEvent, setAnalyticsUserId } from "../firebase/analytics";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
const userInfo = JSON.parse(localStorage.getItem("userInfo"));

export const useFirebasePageTracking = (menuName) => {
  const location = useLocation();

  useEffect(() => {
    const localHostnames = ["localhost", "ngrok", "devtunnels", "trial"];

    const isLocalTesting = localHostnames.some((localHostname) =>
      window.location.hostname.includes(localHostname)
    );

    if (userInfo?.company && !isLocalTesting) {
      setAnalyticsUserId(userInfo.company);
    }

    if (userInfo?.company && menuName && !isLocalTesting) {
      logAnalyticsEvent("page_view", {
        company: userInfo.company,
        menu_name: menuName,
        environment: userInfo.environment,
      });
    }
  }, [location, menuName]);
};
